
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import Swiper from 'swiper'
import 'animate.css'
import COVERAPP from '@/utils/COVERAPP'
import moment from 'moment'

let swiperPage, sharePosterData;
@Options({
  data () {
    return {
      agree: false,
      pageIndex: 0,
      userTop: '荥经****队,fm****66,金中***61,fm****01,信不****你,do****lg,大眼****笑,马边****记,fm****16,fm****88',
      info: {},
      isInitSwiper: false,
      shareLottery: false,
    }
  },
  computed: {
    ...mapState(['aid', 'userInfo','shareData', 'activityData']),
    care() {
      const { discuss_cnt, share_cnt, like_cnt } = this.info;
      if (!discuss_cnt && !share_cnt && !like_cnt) {
        return 1;
      }

      if (discuss_cnt > share_cnt && discuss_cnt > like_cnt) {
        return 2;
      }

      if (share_cnt > discuss_cnt && share_cnt > like_cnt) {
        return 3;
      }

      if (like_cnt > discuss_cnt && like_cnt > share_cnt) {
        return 4;
      }
    },  // 计算用户标签；1-陪伴，2-沟通，3-分享，3-聆听
    // 是否是深夜
    isNight() {
      if (this.info.use_time_lately && new Date(this.info.use_time_lately).getHours() < 5) {
        return true;
      }

      return false;
    },
  },
  mounted () {
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入内页')
    // this.getReport()
  },
  /* beforeDestroy() {
    swiperPage.destroy();
  }, */
  methods: {
    ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
    handleAgree() {
      this.agree = !this.agree;
      this.$common.track('click', '同意隐私协议')
    },
    handleStart() {
      const _this = this;
      if (this.agree && COVERAPP.Attribute.isApp()) {
        /* const $audio: any = document.getElementById('audio');
        $audio.play(); */
        this.$common.track('click', '开始回顾')
        this.$common.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          if (userinfo.token) {
            _this.SET_USERINFO(userinfo);
            _this.pageIndex = 1
            _this.getReport()
            _this.$nextTick(() => {
              _this.createPetal()
            })
            return;
          }

          COVERAPP.Method.OpenLogin({
            callback: (res) => {
              if (res) {
                try {
                  /* const userinfo = JSON.parse(res);
                  _this.SET_USERINFO(userinfo);
                  _this.pageIndex = 1
                  _this.getReport()
                  _this.$nextTick(() => {
                    _this.createPetal()
                  }) */
                } catch (e) {
                  console.log(e);
                }
                return;
              }

              _this.SET_DIALOGDATA({
                text: '请先登录~',
                btns: [
                  {
                    text: '确定',
                    className : 'cancel-btn'
                  },
                ]
              })
            }
          });

        });
      } else {
        this.SET_DIALOGDATA({
          text: '请先勾选同意授权',
          btns: [
            {
              text: '确定',
              className : 'cancel-btn'
            },
          ]
        })
      }
    },
    async getReport() {
      let res = await this.$request('/temporary/report/2023', {
        aid: this.aid,
        userinfo: this.userInfo,
      }, 'post').catch(err => {
        if (err.errno === 1200) {
          this.initSwiper();
        }
      });

      if (res.user_id == 10852) {
        res.date_joined = '2016-03-23 09:00:00';
      }

      // 处理频道标签
      let channel = [];
      if (res.channel_label) {
        try {
          channel = res.channel_label.split(", ").map(item => item.replace(/\[|]/g, ''));
          res.channel = channel;
        }
        catch (e) {
          console.log(e);
        }
      }

      let join_days = res.join_days;
      // 动态计算加入时间
      if (join_days && res.date_joined) {
        join_days = moment(this.activityData.serverTime).diff(res.date_joined, 'days');
        res.join_days = join_days;
      }

      // 时间段计算
      if (res.visit_hour_distr === '05:00——10:00') {
        res.hour_num = 26;
      } else if (res.visit_hour_distr === '10:00——18:00') {
        res.hour_num = 42;
      } else if (res.visit_hour_distr === '18:00——21:00') {
        res.hour_num = 21;
      } else {
        res.hour_num = 11;
      }

      // 打开次数排名计算
      let openRank = 1;
      if (res.open_app_cnt) {
        if (res.open_app_cnt >= 5000) {
          openRank = 99;
        } else if (res.open_app_cnt < 5000 && res.open_app_cnt >= 500) {
          openRank = Math.floor(50 + res.open_app_cnt / 90);
        } else if (res.open_app_cnt < 500) {
          openRank = Math.floor(res.open_app_cnt / 9);
        }

        if (openRank >= 100) {
          openRank = 99;
        }

        if (openRank < 1) {
          openRank = 1;
        }
      }

      // 阅读数排名计算
      let readRank = 1;
      if (res.news_read_cnt) {
        if (res.news_read_cnt >= 5000) {
          readRank = 99;
        } else if (res.news_read_cnt < 5000 && res.news_read_cnt >= 500) {
          readRank = Math.floor(50 + res.news_read_cnt / 90);
        } else if (res.news_read_cnt < 500) {
          readRank = Math.floor(res.news_read_cnt / 9);
        }

        if (readRank >= 100) {
          readRank = 99;
        }

        if (readRank < 1) {
          readRank = 1;
        }
      }

      res.rank = Math.floor(openRank * 0.4 + readRank * 0.6);

      this.info = res;
      this.$nextTick(() => {
        this.initSwiper();
      })
    },
    initSwiper() {
      const _this = this;
      // 船游路径动画
      const ships = [
        `translate(-18vw, -26vw)`,
        `translate(-30vw, -41vw)`,
        `translate(-42vw, -56vw) rotate(25deg)`,
        // `translate(-51vw, -67vw) rotate(30deg) scale(0.95)`,
        `translate(-51vw, -78vw) rotate(50deg) scale(0.9)`,
        `translate(-21vw, -83vw) rotate(100deg) scale(0.9)`,
        `translate(-6vw, -89vw) rotate(110deg) scale(0.85)`,
        `translate(6vw, -71vw) rotate(130deg) scale(0.9)`,
        `translate(21vw, -64vw) rotate(160deg) scale(0.95)`,
        `translate(9vw, -73vw) rotate(240deg) scale(1)`,
        `translate(-5vw, -62vw) rotate(240deg)`,
        `translate(-10vw, -36vw) rotate(230deg)`,
        `translate(-27vw, -13vw) rotate(250deg)`,
        `translate(-61vw, -0vw) rotate(330deg)`,
        `translate(-120vw, -10vw) rotate(330deg)`,
      ];
      swiperPage = new Swiper ('.swiper', {
        direction: 'vertical', // 垂直切换选项
        // initialSlide: 14,
        on: {
          init() {
            _this.isInitSwiper = true;
            _this.drewShare();
          },
          slideChangeTransitionEnd(e) {
            _this.pageIndex = e.activeIndex + 1;
            const $ship: any = document.querySelector('.ship');
            $ship.style.transform = ships[e.activeIndex - 1];
          },
          reachEnd() {
            _this.$common.track('load', '到最后一页');
            swiperPage.allowSlidePrev = false;
            // swiperPage.allowSlideNext = false;
          },
        },
      })
    },
    handleReload() {
      this.$common.track('click', '重新回顾');
      swiperPage.allowSlidePrev = true;
      swiperPage.slideTo(0);
      const $ship: any = document.querySelector('.ship');
      $ship.style.transform = `translate(0vw, 0vw)`;
    },
    handleLotteryLoad() {
      this.$common.onshare({
        ...this.share,
        link: window.location.href
      });
    },
    handleOpenNews(id, flag) {
      window.location.href = `cover://cn.thecover.www/news?id=${id}&flag=${flag}`
    },
    createPetal() {
      for (let i = 0; i < 10; i++) {
        let petal = document.createElement('img')
        const petalLeft = Math.random() * 100;
        petal.style.position = 'fixed'
        petal.style.width = (Math.random() * 5 + 2) + 'vw'
        petal.style.left = petalLeft + 'vw'
        petal.style.bottom = (-Math.random() * 10 - 5) + 'vw'
        petal.style.animation = `${ petalLeft > 50 ? 'petal2' : 'petal1' } ${ Math.random() * 10 + 10 }s ${ Math.random() * 10 }s linear infinite`
        petal.src = 'img/petal.png'
        this.$refs.petal.appendChild(petal)
      }
    },
    handleSharePoster() {
      const _this = this;
      this.$common.track('click', '分享海报');
      COVERAPP.Method.shareImage({
        ...this.shareData,
        image: sharePosterData.split(';base64,')[1],
        callback(res) {
          try {
            const { status } = JSON.parse(res);
            if (status === 'success') {
              _this.$common.track('share', '海报分享成功');
              // _this.shareLottery = true;
              window.location.href = 'https://h5.thepage.cn/jifenTurnCardv1/#/?id=31126EED8CBC32D6';
            }
          } catch (e) {
            console.log(e)
          }
        }
      });
    },
    drewShare() {
      const userInfo = this.userInfo;
      let nickname = userInfo.nickname || '封面用户';
      nickname = nickname.slice(0, 2) + '*' + nickname.slice(-1);
      const { join_days, open_app_days, open_app_cnt, news_read_cnt, rank_per, rank } = this.info;
      const careLink = [
        'https://yunyingcdn.thecover.cn/o_1hhm8na5fdl1o39egt1om9g50d.png',
        'https://yunyingcdn.thecover.cn/o_1hhm8na5f11sb5cn17gqnb42avb.png',
        'https://yunyingcdn.thecover.cn/o_1hhm64vvokfs1s2b1fpp15dcv0re.png',
        'https://yunyingcdn.thecover.cn/o_1hhm8na5f1nil10bd1aer8sso67c.png',
      ];
      let bgImg = 'https://yunyingcdn.thecover.cn/o_1hhmds9timvq1v0kf6re811lm09.jpg';
      let userType = 1;  // 用户类型，1-普通用户；2-新用户；3-沉寂用户
      if (!open_app_cnt) {
        bgImg = 'https://yunyingcdn.thecover.cn/o_1hhtp50dc61d1771l511sbl1hel9.jpg';
        userType = 2;
        if (join_days) {
          userType = 3;
          bgImg = 'https://yunyingcdn.thecover.cn/o_1hhtp549d1rhk1n9qjuf1v2at6ee.jpg';
        }
      }
      const careImg = careLink[this.care - 1];
      const bg = new Image();
      bg.crossOrigin = 'Anonymous';
      bg.src = bgImg;
      bg.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = bg.width;
        canvas.height = bg.height;
        const ctx: any = canvas.getContext('2d');
        ctx.drawImage(bg, 0, 0, bg.width, bg.height);
        const care = new Image();
        care.crossOrigin = 'Anonymous';
        care.src = careImg;
        care.onload = () => {
          ctx.font = '34px "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif';
          ctx.textAlign = 'center';
          ctx.fillStyle = '#008cfa';
          if (userType === 1) {
            ctx.fillText(nickname, 626, 683);
            ctx.fillText(join_days, 751, 744);
            ctx.fillText(open_app_days, 682, 866);
            ctx.fillText(open_app_cnt, 666, 926);
            ctx.fillText(news_read_cnt, 545, 986);
            ctx.fillText(rank, 632, 1046);
            ctx.drawImage(care, canvas.width * 0.3614, canvas.width * 1.1207, care.width, care.height);
          }
          if (userType === 2) {
            ctx.fillText(nickname, 626, 715);
          }
          if (userType === 3) {
            ctx.fillText(nickname, 626, 696);
            ctx.fillText(join_days, 751, 767);
          }
          
          sharePosterData = canvas.toDataURL('image/jpeg');
          // console.log(sharePosterData);
          // document.getElementById('share')?.appendChild(canvas);
        }
      }
    },
    hour_text(num = 26) {
      const texts = {
        t_26: '清晨',
        t_42: '工作',
        t_21: '傍晚',
        t_11: '深夜',
      };

      return texts['t_' + num];
    },
  }
})
export default class Home extends Vue {}
